export default theme => ({
  select_label: {
    fontSize: 12,
  },
});
